import { render, staticRenderFns } from "./VenueView_WaiterListOverview.vue?vue&type=template&id=390a7e22&"
import script from "./VenueView_WaiterListOverview.vue?vue&type=script&lang=js&"
export * from "./VenueView_WaiterListOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports